import axios from 'axios';

// Client for the eIFU country-visibility exceptions API (SPEC-002), backed by D1
// via Pages Functions. The public portal reads the rules and applies them when a
// visitor picks a country; the admin console creates/deletes rules through the
// Access-gated endpoint under /admin.
//
//   READ   — GET    /api/visibility            (public)
//   CREATE — POST   /admin/api/visibility       (Cloudflare Access)
//   DELETE — DELETE /admin/api/visibility?id=…  (Cloudflare Access)
const READ_URL = '/api/visibility';
const WRITE_URL = '/admin/api/visibility';

// Fetch all exception rules. Returns [] on failure so the portal degrades to
// "show everything" (no exceptions applied).
export const getExceptions = async () => {
  try {
    const res = await axios.get(READ_URL);
    return Array.isArray(res?.data?.exceptions) ? res.data.exceptions : [];
  } catch (error) {
    console.warn('ERROR[getExceptions]', error?.toString());
    return [];
  }
};

// Create one exception rule. Sends credentials so the Cloudflare Access cookie
// rides along; the Function verifies it before writing.
// rule: { countries: ["DE",...], appName, mode: 'hide'|'versions', versions: [...] }
export const addException = async (rule) => {
  const res = await axios.post(WRITE_URL, rule, { withCredentials: true });
  return res?.data;
};

export const deleteException = async (id) => {
  const res = await axios.delete(WRITE_URL, {
    params: { id },
    withCredentials: true,
  });
  return res?.data;
};

// Visitor country detected at the Cloudflare edge (ISO 3166-1 alpha-2). Returns
// '' on failure / unknown so the portal falls back to no preselection.
export const getGeoCountry = async () => {
  try {
    const res = await axios.get('/api/geo');
    const code = res?.data?.country;
    return typeof code === 'string' ? code : '';
  } catch (error) {
    return '';
  }
};
